import { render, staticRenderFns } from "./blogdetails.vue?vue&type=template&id=1dca6526"
import script from "./blogdetails.vue?vue&type=script&lang=js"
export * from "./blogdetails.vue?vue&type=script&lang=js"
import style0 from "./blogdetails.vue?vue&type=style&index=0&id=1dca6526&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports